import { render, staticRenderFns } from "./imageAndText.vue?vue&type=template&id=35ea0413&scoped=true&"
import script from "./imageAndText.vue?vue&type=script&lang=js&"
export * from "./imageAndText.vue?vue&type=script&lang=js&"
import style0 from "./imageAndText.vue?vue&type=style&index=0&id=35ea0413&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ea0413",
  null
  
)

export default component.exports